import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

export interface CrmReceiptDetailsPanelProps {
  recipientName: string;
  onRecipientNameChange: (value: string) => void;
  issuedFor: string;
  onIssuedForChange: (value: string) => void;
  note: string;
  onNoteChange: (value: string) => void;
  loading?: boolean;
  kicker: string;
  infoText: string;
  idPrefix?: string;
}

export const CrmReceiptDetailsPanel: React.FC<CrmReceiptDetailsPanelProps> = ({
  recipientName,
  onRecipientNameChange,
  issuedFor,
  onIssuedForChange,
  note,
  onNoteChange,
  loading = false,
  kicker,
  infoText,
  idPrefix = 'crm-receipt',
}) => {
  const recipientId = `${idPrefix}-recipient-name`;
  const issuedForId = `${idPrefix}-issued-for`;
  const noteId = `${idPrefix}-note`;

  return (
    <>
      <style>
        {`
            .crm-add-payment-receipt-panel {
              border-radius: 12px;
              border: 1px solid #e2e8f0;
              background: linear-gradient(165deg, #ffffff 0%, #f8fafc 55%, #f1f5f9 100%);
              box-shadow:
                0 4px 6px -1px rgba(15, 23, 42, 0.07),
                0 2px 4px -2px rgba(15, 23, 42, 0.05);
              border-inline-start: 4px solid #0d9488;
              padding: 1.125rem 1.25rem;
              min-width: 0;
              width: 100%;
              box-sizing: border-box;
            }
            .crm-add-payment-receipt-panel .receipt-panel-header {
              display: flex;
              align-items: flex-start;
              gap: 0.75rem;
              margin-bottom: 1rem;
            }
            .crm-add-payment-receipt-panel .receipt-panel-icon-wrap {
              flex-shrink: 0;
              width: 2.5rem;
              height: 2.5rem;
              border-radius: 10px;
              background: linear-gradient(135deg, #ccfbf1 0%, #99f6e4 100%);
              color: #0f766e;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.125rem;
              box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
            }
            .crm-add-payment-receipt-panel .receipt-panel-title {
              margin: 0;
              font-size: 1.125rem;
              font-weight: 700;
              color: #0f172a;
              letter-spacing: -0.02em;
              line-height: 1.3;
            }
            .crm-add-payment-receipt-panel .receipt-panel-kicker {
              display: block;
              font-size: 0.75rem;
              font-weight: 500;
              color: #64748b;
              margin-top: 0.2rem;
            }
            .crm-add-payment-receipt-panel .receipt-panel-info {
              display: flex;
              align-items: flex-start;
              gap: 0.5rem;
              font-size: 0.8125rem;
              line-height: 1.65;
              color: #475569;
              background: #f0fdfa;
              border: 1px solid #99f6e4;
              border-radius: 8px;
              padding: 0.75rem 0.875rem;
              margin-bottom: 1.125rem;
            }
            .crm-add-payment-receipt-panel .receipt-panel-info .pi-info-circle {
              flex-shrink: 0;
              margin-top: 0.12rem;
              color: #0d9488;
              font-size: 0.95rem;
            }
            .crm-add-payment-receipt-panel .crm-receipt-fields-grid {
              display: grid;
              grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
              column-gap: 0.5rem;
              row-gap: 0.75rem;
              align-items: start;
              width: 100%;
            }
            .crm-add-payment-receipt-panel .receipt-field-group {
              width: 100%;
              min-width: 0;
              box-sizing: border-box;
            }
            .crm-add-payment-receipt-panel .crm-receipt-fields-grid .receipt-field-group {
              margin-bottom: 0;
            }
            .crm-add-payment-receipt-panel .crm-receipt-note-span {
              grid-column: 1 / -1;
              width: 100%;
            }
            @media (max-width: 520px) {
              .crm-add-payment-receipt-panel .crm-receipt-fields-grid {
                grid-template-columns: minmax(0, 1fr);
              }
            }
            .crm-add-payment-receipt-panel .receipt-field-label {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 0.35rem;
              font-size: 0.875rem;
              font-weight: 600;
              color: #334155;
              margin-bottom: 0.4rem;
            }
            .crm-add-payment-receipt-panel .receipt-optional-pill {
              font-size: 0.65rem;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.04em;
              color: #64748b;
              background: #e2e8f0;
              padding: 0.15rem 0.45rem;
              border-radius: 4px;
            }
            .crm-add-payment-receipt-panel .receipt-field-hint {
              font-size: 0.6875rem;
              color: #94a3b8;
              margin-top: 0.3rem;
            }
            .crm-add-payment-receipt-panel .p-inputtext {
              width: 100%;
              max-width: 100%;
              box-sizing: border-box;
              border-radius: 8px;
              border-color: #cbd5e1;
              transition: border-color 0.15s ease, box-shadow 0.15s ease;
            }
            .crm-add-payment-receipt-panel .p-inputtext:enabled:hover {
              border-color: #94a3b8;
            }
            .crm-add-payment-receipt-panel .p-inputtext:enabled:focus {
              border-color: #0d9488;
              box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.18);
            }
            .crm-add-payment-receipt-panel .p-inputtextarea {
              width: 100%;
              max-width: 100%;
              box-sizing: border-box;
              border-radius: 8px;
              border-color: #cbd5e1;
              transition: border-color 0.15s ease, box-shadow 0.15s ease;
              min-height: 3.25rem;
              resize: vertical;
            }
            .crm-add-payment-receipt-panel .p-inputtextarea:enabled:hover {
              border-color: #94a3b8;
            }
            .crm-add-payment-receipt-panel .p-inputtextarea:enabled:focus {
              border-color: #0d9488;
              box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.18);
            }
          `}
      </style>
      <div className="crm-add-payment-receipt-panel">
        <div className="receipt-panel-header">
          <div className="receipt-panel-icon-wrap" aria-hidden>
            <i className="pi pi-file-edit" />
          </div>
          <div>
            <h3 className="receipt-panel-title">פרטי קבלה</h3>
            <span className="receipt-panel-kicker">{kicker}</span>
          </div>
        </div>
        <div className="receipt-panel-info">
          <i className="pi pi-info-circle" aria-hidden />
          <span>{infoText}</span>
        </div>
        <div className="crm-receipt-fields-grid" style={{ width: '100%' }}>
          <div className="receipt-field-group">
            <label htmlFor={recipientId} className="receipt-field-label">
              לכבוד
            </label>
            <InputText
              id={recipientId}
              value={recipientName}
              onChange={(e) => onRecipientNameChange(e.target.value)}
              className="w-full"
              maxLength={100}
              dir="rtl"
              disabled={loading}
            />
            <div className="receipt-field-hint">עד 100 תווים</div>
          </div>
          <div className="receipt-field-group">
            <label htmlFor={issuedForId} className="receipt-field-label">
              עבור
              <span className="receipt-optional-pill">אופציונלי</span>
            </label>
            <InputText
              id={issuedForId}
              value={issuedFor}
              onChange={(e) => onIssuedForChange(e.target.value)}
              className="w-full"
              maxLength={100}
              dir="rtl"
              disabled={loading}
              placeholder="למשל: מבחן תיל"
            />
            <div className="receipt-field-hint">עד 100 תווים</div>
          </div>
          <div className="receipt-field-group crm-receipt-note-span">
            <label htmlFor={noteId} className="receipt-field-label">
              הערה
              <span className="receipt-optional-pill">אופציונלי</span>
            </label>
            <InputTextarea
              id={noteId}
              value={note}
              onChange={(e) => onNoteChange(e.target.value)}
              className="w-full"
              maxLength={200}
              rows={2}
              autoResize
              dir="rtl"
              disabled={loading}
              placeholder="הערה לתיעוד (אופציונלי)…"
            />
            <div className="receipt-field-hint">עד 200 תווים</div>
          </div>
        </div>
      </div>
    </>
  );
};
